import React from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";

import { SigninFastLogin } from "./signin-fast-login";
import { FormSignInEmail } from "../../containers/forms/form-auth/form-sign-in-email";
import { Form } from "../../components/ui/form";
import { Button } from "../../components/ui/button";
import { DottedMap } from "../../components/ui/dotted-map";
import { configProject } from "../../config-project";

interface SignInPageProps {
    onSignInEmail: (data: {
        email?: string;
        password?: string;
    }) => Promise<void>;
    loading: boolean;
}

export const SignInPage = ({ onSignInEmail, loading }: SignInPageProps) => {
    const form = useForm({
        defaultValues: { email: "", password: "" },
    });

    const actionSignin = async (data: {
        email?: string;
        password?: string;
    }) => {
        await onSignInEmail(data);
    };

    return (
        <div className="relative flex min-h-screen bg-muted dark:bg-background items-center justify-center overflow-hidden">
            {/* Dotted Map Full Background */}
            <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none opacity-80">
                <DottedMap
                    className="w-[200%] md:w-[150%] lg:w-[120%] max-w-[1800px]"
                    dotColor="#c4b5fd"
                    markerColor="#7c3aed"
                    markers={[
                        { lat: 40.7128, lng: -74.0060 }, // New York
                        { lat: 37.5665, lng: 126.9780 }, // Seoul
                        { lat: -23.5505, lng: -46.6333 }, // São Paulo
                    ]}
                />
            </div>

            {/* Login Card */}
            <div className="relative z-10 w-full max-w-md px-4">
                <div className="rounded-2xl border border-border bg-card p-8 shadow-xl">
                    <div className="mb-6 flex flex-col items-center text-center">
                        <img
                            src={require("../../assets/dream-book-logo.png")}
                            alt="Dream Book"
                            className="mb-4 h-16 w-auto"
                        />
                        <h1 className="text-xl font-bold tracking-tight text-foreground">
                            Bem-vindo de volta
                        </h1>
                        <p className="mt-1 text-sm text-muted-foreground">
                            Entre no painel para continuar
                        </p>
                    </div>

                    <Form {...form}>
                        <form
                            onSubmit={form.handleSubmit(actionSignin)}
                            className="space-y-4"
                        >
                            <FormSignInEmail />

                            <div className="flex justify-end">
                                <Link
                                    to="/forgot-password"
                                    className="text-sm font-medium text-primary transition-colors hover:text-primary/80 hover:underline"
                                >
                                    Esqueci minha senha
                                </Link>
                            </div>

                            <Button
                                type="submit"
                                className="h-11 w-full font-semibold"
                                disabled={loading}
                            >
                                {loading ? "Entrando..." : "Entrar"}
                            </Button>

                            {process.env.NODE_ENV === "development" &&
                            process.env.REACT_APP_SHOW_HELPER === "on" ? (
                                <SigninFastLogin />
                            ) : null}
                        </form>
                    </Form>
                </div>
            </div>
        </div>
    );
};
